@switch (true) {
  <!-- In site link and not edit mode -->
  @case (!isExternalLink && !isEditMode) {
    @if (!unavailableLink) {   
      @if (isLgButton) {
        <!-- router link with lg-button directive -->
        <a
          (click)="interactionClickEvent(adobeData)"
          [attr.aria-label]="arialabel"
          [attr.extension]="extension"
          [attr.fileSize]="fileSize"
          [attr.role]="role"
          [attr.tabindex]="tabindex"
          [class]="linkClass"
          [iconPosition]="lgButtonIconPosition"
          [routerLink]="formattedUrl"
          [target]="target"
          [title]="title"
          [variant]="lgButtonVariant"
          lg-button
        >
          <ng-container [ngTemplateOutlet]="content"></ng-container>
        </a>
      } @else {
        <!-- simple router link -->
        <a
          (click)="interactionClickEvent(adobeData)"
          [attr.aria-label]="arialabel"
          [attr.extension]="extension"
          [attr.fileSize]="fileSize"
          [attr.role]="role"
          [attr.tabindex]="tabindex"
          [class]="linkClass"
          [routerLink]="formattedUrl"
          [target]="target"
          [title]="title"
        >
          <ng-container [ngTemplateOutlet]="content"></ng-container>
        </a>
      }
    }
  }
  <!-- external link or edit mode -->
  @case (isEditMode || isExternalLink) {
    @if (isLgButton) {
      <!-- normal link with lg-button directive -->
      <a
        (click)="interactionClickEvent(adobeData); navigate($event)"
        [attr.aria-label]="arialabel"
        [attr.extension]="extension"
        [attr.fileSize]="fileSize"
        [attr.role]="role"
        [attr.tabindex]="tabindex"
        [class]="linkClass"
        [href]="formattedUrl"
        [iconPosition]="lgButtonIconPosition"
        [target]="target"
        [title]="title"
        [variant]="lgButtonVariant"
        lg-button
      >
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </a>
    } @else {
      <!-- simple normal link -->
      <a
        (click)="interactionClickEvent(adobeData); navigate($event)"
        [attr.aria-label]="arialabel"
        [attr.extension]="extension"
        [attr.fileSize]="fileSize"
        [attr.role]="role"
        [attr.tabindex]="tabindex"
        [class]="linkClass"
        [href]="formattedUrl"
        [target]="target"
        [title]="title"
      >
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </a>
    }
  }
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
